<template>
  <div class="filter-field filter-ms">
    <div class="filter-field__label">
      <label :for="fieldId" class="mb-0 font-weight-bold">{{ label }}</label>
      <button
        v-if="selectedIds.length"
        type="button"
        class="btn btn-link btn-sm p-0 ml-2 filter-ms__clear"
        @click="$emit('clear')"
      >Clear</button>
    </div>
    <div class="filter-field__control">
      <app-multiselect
        :id="fieldId"
        :value="selectedOptions"
        :options="options"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :allow-empty="true"
        :show-labels="false"
        :label="optionLabel"
        :track-by="trackBy"
        :placeholder="placeholder"
        :disabled="disabled"
        :limit="2"
        :limit-text="count => `+ ${count} more`"
        @input="onInput"
      />
    </div>
  </div>
</template>

<script>
import AppMultiselect from '@/components/AppMultiselect'

/**
 * One multi-value list filter: a labelled multi-select with a per-filter "Clear".
 * `value` is an array of option ids (see `trackBy`); `input` emits the same shape.
 * Pair with FilterBar + useServerList's array extraFilters / clearFilter / clearFilters.
 */
export default {
  name: 'FilterMultiselect',
  components: { AppMultiselect },
  props: {
    label: { type: String, required: true },
    value: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    trackBy: { type: String, default: 'id' },
    optionLabel: { type: String, default: 'name' },
    placeholder: { type: String, default: 'Any' },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    fieldId() {
      return `filter-${this.label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}`
    },
    // Ids kept as-is from the prop, compared loosely so number ids match string option ids.
    selectedIds() {
      return Array.isArray(this.value) ? this.value : []
    },
    selectedOptions() {
      return this.options.filter(o => this.selectedIds.some(id => String(id) === String(o[this.trackBy])))
    }
  },
  methods: {
    onInput(options) {
      this.$emit('input', (options || []).map(o => o[this.trackBy]))
    }
  }
}
</script>

<style scoped>
.filter-ms {
  width: 230px;
}
.filter-ms .filter-field__control {
  align-items: flex-start;
}
.filter-ms__clear {
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/filters/FilterMultiselect.vue